import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Enregistre chaque page consultée (hors espace admin) pour les statistiques de visite.
const RouteTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/admin')) return;
    axios.post(`${API}/track`, { path }).catch((e) => {
      console.warn('Tracking non enregistré:', e);
    });
  }, [location.pathname]);

  return null;
};

export default RouteTracker;
